import { render } from "./BottomNavigation.vue?vue&type=template&id=1421e8ef&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=ts"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts"

import "./BottomNavigation.vue?vue&type=style&index=0&id=1421e8ef&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1421e8ef"

export default script